import {CSSProperties, FC} from 'react';


export interface IIconWindshieldHeatProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconWindshieldHeat: FC<IIconWindshieldHeatProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="m20.447 5.276-2.78-.758a21.281 21.281 0 0 0-11.337 0l-2.777.758a.75.75 0 0 0-.551.777l.75 10.5a.75.75 0 0 0 .964.665l2.506-.752c.965-.29 1.95-.49 2.943-.6.133.294.227.586.279.879.167.934.082 1.824-.233 2.39a.75.75 0 1 0 1.312.729c.502-.906.62-2.137.397-3.383a5.011 5.011 0 0 0-.183-.714c1.55-.024 3.1.168 4.61.576.04.134.073.268.097.402.167.934.082 1.824-.233 2.39a.75.75 0 1 0 1.312.729c.456-.823.595-1.913.45-3.04l1.311.394a.75.75 0 0 0 .964-.665l.75-10.5a.75.75 0 0 0-.55-.777ZM18.82 15.512l-1.354-.406a7.482 7.482 0 0 0-.922-1.425A3.288 3.288 0 0 1 15.8 12h1.451L15 8.25 12.75 12h1.538a4.79 4.79 0 0 0 1.05 2.575 18.129 18.129 0 0 0-4.343-.282 8.613 8.613 0 0 0-.452-.612A3.288 3.288 0 0 1 9.8 12h1.451L9 8.25 6.75 12h1.538c.102.957.415 1.738.971 2.474a18.13 18.13 0 0 0-2.468.555l-1.61.483-.639-8.95 2.186-.597a19.786 19.786 0 0 1 10.543 0l2.187.596-.64 8.951Z" />
        </svg>
    );
};
